import { css } from "styled-components";
import { carouselNextPrevRiotProduct } from "../../../CarouselNext/skins/riot-product";
export const riotProductSkin = (chroma, paletteTokens) => css `
  ${carouselNextPrevRiotProduct(chroma, paletteTokens)}
`;
//# sourceMappingURL=index.js.map